import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

interface IMaterialIconData {
    name: string,
    url: string
}

@Injectable()
export class JsonConfiguration {
  iconsConfig: IMaterialIconData[] = [
    {
      name: 'alert-circle2',
      url: '../assets/icons/alert-circle2.svg',
    },
    {
      name: 'bike.svg',
      url: '../assets/icons/bike.svg',
    },
    {
      name: 'golf.svg',
      url: '../assets/icons/golf.svg',
    },
    {
      name: 'snow.svg',
      url: '../assets/icons/nieve.svg',
    },
    {
      name: 'clockCountdown',
      url: '../assets/icons/clockCountdown.svg',
    },
    {
      name: 'userCheck',
      url: '../assets/icons/user-check.svg',
    },
    {
      name: 'user',
      url: '../assets/icons/user.svg',
    },
    {
      name: 'checkCircle',
      url: '../assets/icons/check-circle.svg',
    },
    {
      name: 'Bruglar',
      url: '../assets/icons/burglar-yellow.svg',
    },
    {
      name: 'dollar-sign',
      url: '../assets/icons/dollar-sign.svg',
    },
    {
      name: 'lock',
      url: '../assets/icons/lock.svg',
    },
    {
      name: 'clock',
      url: '../assets/icons/clock.svg',
    },
    {
      name: 'Plane',
      url: '../assets/icons/plane.svg',
    },
    {
      name: 'globe',
      url: '../assets/icons/globe.svg',
    },
    {
      name: 'clear',
      url: '../assets/icons/star.svg',
    },
    {
      name: 'star',
      url: '../assets/icons/star.svg',
    },
    {
      name: 'aperture',
      url: '../assets/icons/aperture.svg',
    },
    {
      name: 'settings',
      url: '../assets/icons/settings.svg',
    },
    {
      name: 'help',
      url: '../assets/icons/life-buoy.svg',
    },
    {
      name: 'question-mark',
      url: '../assets/icons/help-circle.svg',
    },
    {
      name: 'pink-phone',
      url: '../assets/icons/pink-phone.svg',
    },
    {
      name: 'pink-whatsapp',
      url: '../assets/icons/pink-whatsapp.svg',
    },
    {
      name: 'pink-email',
      url: '../assets/icons/pink-email.svg',
    },
    {
      name: 'show-less',
      url: '../assets/icons/show_less.svg',
    },
    {
      name: 'rigth-down-pink-arrow',
      url: '../assets/icons/rigth-down-pink-arrow.svg',
    },
    {
      name: 'refund',
      url: '../assets/icons/refund.svg',
    },
    {
      name: 'closeCircleErr',
      url: '../assets/icons/close-circle-err.svg',
    },
  ];

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}

  addSvgIcons() {
    this.iconsConfig.forEach((icon) => {
      this.matIconRegistry.addSvgIcon(
        icon.name,
        this.domSanitizer.bypassSecurityTrustResourceUrl(icon.url)
      );
    });
  }
}
